import React, { useEffect, useState } from 'react';
import Announcement from './Announcement';
import parse from 'html-react-parser';

function Announcements() {

  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
          fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=getAllAnnouncements")
              .then(response => response.json())
              .then(data => {
                  if (data.success) {
                      setAnnouncements(data.announcements);
                  } else {
                      console.error("API Error:", data.error);
                  }
              })
              .catch(error => console.error("Error fetching announcements:", error));
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    return (
      <>
        <div className="ann_section">
            <div className="ann_wrapper">
                <div className="section_hr">

                </div>
                <p className='section_title'>Announcements</p>


                <div className='ann_all_blocks'>

                  {announcements.slice(0,3).map((announcement, index) => (  

                      <Announcement key={announcement.id} link={'/announcement/' + announcement.id + '/' + announcement.title.toLowerCase().replace(/\s+/g, '-')} fullstring="false" last={index === announcements.slice(0,3).length - 1 ? "true" : "false"} title={parse(announcement.title)} date={formatDate(announcement.date)} content={parse(announcement.body)}/>     

                  ))}
                   
                </div>

            </div>
        </div>
      </>
    );
}

export default Announcements;


